import { Box } from "@mui/material";
import React from "react";
import CustomTabButton from "../../unit/CustomTabButton";
import CustomDetailBox from "./CustomDetailBox";
import CustomSummaryEmailHistory from "./CustomSummaryEmailHistory";
import CustomSummaryTextHistory from "./CustomSummaryTextHistory";
import CustomSummaryMessageHistory from "./CustomSummaryMessageHistory";

const CustomSummaryMessageTabList = ({ ...props }) => {
  const userId = props.userId;
  let record = props.record;
  const [activeTab, setActiveTab] = React.useState(1);
  record = props.record;

  const handleChange = (newValue: number) => {
    setActiveTab(newValue);
  };
  return (
    <Box sx={{ width: "100%", pt: 0, height: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <CustomTabButton
          variant="text"
          onClick={() => handleChange(1)}
          className={activeTab === 1 ? "Mui-selected" : ""}
          id="btn-show-tab-email-history"
        >
          Email
        </CustomTabButton>
        <CustomTabButton
          variant="text"
          onClick={() => handleChange(2)}
          className={activeTab === 2 ? "Mui-selected" : ""}
          id="btn-show-tab-text-history"
        >
          Text
        </CustomTabButton>
        <CustomTabButton
          variant="text"
          onClick={() => handleChange(3)}
          className={activeTab === 3 ? "Mui-selected" : ""}
          id="btn-show-tab-message-history"
        >
          Message
        </CustomTabButton>
      </Box>
      <CustomDetailBox sx={{ display: activeTab === 1 ? "block" : "none" }}>
        <CustomSummaryEmailHistory userId={userId} />
      </CustomDetailBox>
      <CustomDetailBox sx={{ display: activeTab === 2 ? "block" : "none" }}>
        <CustomSummaryTextHistory userId={userId} />
      </CustomDetailBox>
      <CustomDetailBox sx={{ display: activeTab === 3 ? "block" : "none" }}>
        <CustomSummaryMessageHistory userId={userId} />
      </CustomDetailBox>
    </Box>
  );
};

export default CustomSummaryMessageTabList;
